module.exports = __webpack_public_path__ + "img/2-aleph.21e0d5c5.png";